import React from 'react'

function FAQ() {
  return (
    <div style={{borderBottom:"1px solid white"}}>
        <div className='title'>
            <h2>Frequently Asked Questions</h2>
        </div>
        <div className='content-pp' style={{width:"85%", margin:"auto", marginBottom:"10vh"}}>
            <h3 className='heading'>1. How can I book a badminton court?</h3>
            <p className='heading-content'>
                To book a badminton court, please visit our website and navigate to the "Bookings" page. Select the desired date, time, and number of players. Follow the prompts to complete the booking process and make the payment.
            </p>

            <h3 className='heading'>2. What is the duration of a standard badminton game?</h3>
            <p className='heading-content'>
                A standard badminton game consists of three sets. Each set is played to 21 points, with a two-point lead required to win the set. On average, a game can last between 30 minutes to an hour, depending on the skill level and pace of play.
            </p>

            <h3 className='heading'>3. Do I need to bring my own equipment?</h3>
            <p className='heading-content'>
                While we provide basic badminton equipment, such as rackets and shuttlecocks, you are welcome to bring your own equipment if you prefer. It is recommended to bring proper sports attire and non-marking shoes to ensure a comfortable and safe playing experience.
            </p>

            <h3 className='heading'>4. Can I cancel or reschedule my booking?</h3>
            <p className='heading-content'>
                Yes, you can cancel or reschedule your booking based on our cancellation policy. To make changes to your booking, please log in to your account and go to the "My Bookings" section. From there, you can manage your bookings and follow the instructions to cancel or reschedule as needed.
            </p>

            <h3 className='heading'>5. Are there any membership options available?</h3>
            <p className='heading-content'>
                Yes, we offer membership options for frequent players. Our membership packages provide various benefits, such as discounted rates, priority booking, and exclusive access to member-only events. Please visit the "Membership" page on our website for more information and to sign up.
            </p>

            <h3 className='heading'>6. Are there coaching services available?</h3>
            <p className='heading-content'>
                Yes, we offer coaching services for players of all skill levels. Our experienced coaches provide personalized training sessions to help improve your badminton skills. You can find more details about our coaching programs on the "Coaching" page and contact us to schedule a session.
            </p>

            <h3 className='heading'>7. Can I host a badminton tournament at your facility?</h3>
            <p className='heading-content'>
                Absolutely! We have the resources and space to host badminton tournaments. Whether it's a friendly competition or a professional event, we can accommodate your needs. Please reach out to us through the "Contact" page to discuss your tournament requirements and make the necessary arrangements.
            </p>

            <h3 className='heading'>8. Is there a pro shop on-site?</h3>
            <p className='heading-content'>
                Yes, we have a pro shop on-site where you can purchase badminton equipment, apparel, and accessories. Our shop offers a wide range of products from top brands. Feel free to visit the pro shop during your visit to browse and buy the items you need.
            </p>

            <h3 className='heading'>9. What are the facilities available apart from badminton courts?</h3>
            <p className='heading-content'>
                In addition to badminton courts, we offer various facilities like,
                <br /><br /> - Changing rooms and locker facilities
                <br /> - Shower and restroom facilities
                <br /> - Spectator seating area
                <br /> - Snack bar or cafeteria for refreshments
                <br /> - Ample parking space
                <br /> - Proximity to public transportation
            </p>
            <h3 className='heading'>10. Can I rent equipment if I don't have my own?</h3>
            <p className='heading-content'>
                Yes, we offer equipment rental services for players who do not have their own gear. You can rent badminton rackets, shuttlecocks, and other necessary equipment at our facility. Rental fees may apply, and availability is subject to demand. Please inquire at the reception or contact us for more details.
            </p>

            <h3 className='heading'>11. Are there any age restrictions for using the badminton courts?</h3>
            <p className='heading-content'>
                There are no specific age restrictions for using the badminton courts. Players of all ages are welcome to enjoy the sport. However, for the safety of younger players, we recommend adult supervision or participation for children below a certain age. Please check our guidelines or consult with our staff for any specific age-related policies.
            </p>

            <h3 className='heading'>12. How do I get updates on upcoming events and promotions?</h3>
            <p className='heading-content'>
                To stay updated on upcoming events, promotions, and special offers, you can subscribe to our newsletter. Simply provide your email address on our website's subscription form, and you will receive regular updates in your inbox. You can also follow us on social media platforms for real-time updates and announcements.
            </p>

            <h3 className='heading'>13. Can I bring guests who are not playing?</h3>
            <p className='heading-content'>
                Yes, you are welcome to bring guests who are not playing. They can accompany you to the facility and enjoy the spectator seating area while you play. However, please note that access to the playing area may be restricted to players only for safety and security reasons.
            </p>

            <h3 className='heading'>14. What are the accepted payment methods?</h3>
            <p className='heading-content'>
                We accept various payment methods, including cash, credit cards, and mobile payment apps. Please check with our staff or refer to the payment options displayed at the reception or on our website for specific details on accepted payment methods.
            </p>

            <h3 className='heading'>15. How can I contact customer support?</h3>
            <p className='heading-content'>
                If you have any further questions, concerns, or require assistance, our customer support team is available to help. You can reach us through the contact information provided on our website, including phone, email, or the contact form. We strive to respond promptly and provide the necessary support.
            </p>
        </div>
    </div>
  )
}

export default FAQ

/*
<!DOCTYPE html>
<html>
<head>
    <title>FAQ</title>
</head>
<body>
    
</body>
</html>

*/